import React from 'react';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

const BaseDescriptionList: React.FC<IProps> = ({ children, className }) => {
  return <dl className={className}>{children}</dl>;
};

export default BaseDescriptionList;
